export default {
  'intl-locale': 'en-US',
  system: {
    loading: 'Loading...',
    error: {
      title: 'System failure',
      message: 'Sorry, there was a system failure. Try again.'
    }
  },
  filter: {
    select: 'Select',
    'btn-submit-text': 'Filter',
    'btn-clear-text': 'Clear',
    'nav-between-groups': 'Filter group {{group}}/{{totalGroup}}',
    'complement-or': 'Filter - Complementary (OR)',
    'refine-and': 'Filter - Refine (AND)',
    loading: 'Loading filter...',
    filters: 'Filters'
  },
  'filter-composition': {
    'label-field': 'Filter composition'
  },
  filteractions: {
    'select-label': 'Filter Actions',
    'initial-selection': 'Initial filter reset'
  },
  pagination: {
    pages: 'Pages',
    'go-to-page': 'Go to page'
  },
  'data-table': {
    selection: 'Selection',
    actions: 'Actions',
    'no-records-found': 'No records found',
    'select-all': 'Select all',
    'navigate-between-table-columns': 'Navigate between table columns',
    previous: 'Previous',
    next: 'Next'
  },
  multifree: {
    item: 'item',
    items: 'items',
    add: 'add',
    remove: 'remove',
    clear: 'clear'
  },
  uniselection: {
    clear: 'clear',
    'show-options': 'show options',
    'hide-options': 'hide options'
  },
  multiselection: {
    clear: 'clear',
    'show-options': 'show options',
    'hide-options': 'hide options',
    selection: 'selection',
    selections: 'selections',
    'option-selected': 'option selected',
    'options-selected': 'options selected',
    selections_one: '{{count}} selection',
    selections_multiple: '{{count}} selections'
  },
  datepicker: {
    select: 'Select'
  },
  'navigation-slider': {
    previous: 'Go to previous',
    next: 'Go to next',
    beginning: 'Go to the beginning',
    last: 'Go to last',
    showPassword: 'Show password',
    hidePassword: 'Hide password'
  },
  task: {
    model: 'Task Model',
    sid: 'Task SID',
    'assigned-requester': 'Assigned Requester',
    'assigned-executor': 'Assigned Executor',
    'scheduled-submission': 'Scheduled Submission at',
    'scheduled-start': 'Scheduled Start at',
    priority: {
      low: 'low',
      normal: 'normal',
      high: 'high',
      urgent: 'urgent'
    },
    action: {
      approve: 'Approve',
      cancel: 'Cancel',
      copy: 'Copy',
      deliver: 'Deliver',
      lock: 'Lock',
      'mark-as-failed': 'Mark as failed',
      pause: 'Pause',
      reject: 'Reject',
      restart: 'Restart',
      resume: 'Resume',
      return: 'Return',
      start: 'Start',
      take: 'Take',
      unlock: 'Unlock',
      view: 'View',
      execute: 'Execute'
    }
  },
  'loading-page': {
    heading: 'The page is being loaded',
    complement: 'This can take a few minutes.\nPlease wait.'
  },
  'transfer-order-card': {
    shipper: 'Shipper',
    receiver: 'Receiver',
    'delivery-order': 'Delivery Order',
    'receipt-order': 'Receipt Order',
    'order-table-header': 'Order | Description | Qty | Measuring Unit',
    view: 'View'
  },
  'route-section': {
    'sid-label': 'Route SID',
    estimated: 'Estimated Time and Estimated Quilometers'
  },
  'transport-card': {
    route: 'Route',
    checkpoints: 'Checkpoints'
  },
  'checkpoint-section': {
    status: {
      todo: 'To Visit',
      doing: 'Started',
      done: 'Done'
    },
    'map-button': 'Map',
    view: 'View',
    'transfer-order': 'Transfer Orders'
  },
  'priority-tag': {
    low: 'low',
    normal: 'normal',
    high: 'high',
    urgent: 'urgent'
  },
  'training-card': {
    duration: 'Duration time',
    seconds: 'seconds',
    minutes: 'minutes',
    'play-video': 'play video'
  },
  '503-error': {
    title: 'We are temporarily unavailable',
    'description-1': 'Our services are currently unavailable.',
    'description-2': 'Please go to the home page or try again in a moment.',
    'try-again': 'Try again',
    'alt-img': 'Error 503'
  },
  saf: {
    legend: 'Legend',
    in: 'In',
    out: 'Out',
    'initial-stock': 'Initial stock',
    'final-stock': 'Final stock',
    totals: 'Totals'
  },
  'text-fading': {
    'read-more': 'Read more',
    'read-less': 'Read less'
  },
  accordion: {
    'summary-item': 'Summary item',
    'toggle-accordion': 'Toggle accordion'
  },
  'contact-object-card': {
    'phone-number': 'Phone number'
  }
}
